module.exports = __webpack_public_path__ + "static/media/naked-and-asleep.33adc3cd.mp3";